// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2DfL-","input":"styles_input__1KOJX"};